import styled, { css } from "styled-components";
import { lighten, darken } from "polished";

export const Input = css`
    background-color: ${p => p.theme.c.cardBackground};
    width: 100%;
    font-size: 17px;
    border: ${p => p.theme.mode === "dark" ? p.theme.c.cardBackground : p.theme.c.disabled} 1px solid;
    padding: 9px 16px;
    box-sizing: border-box;
    resize: none;
    font-weight: 300;
    appearance: none;
    border-radius: 8px;

    &:focus {
        outline: none;
        border: 1px solid ${p => p.theme.c.active};
    }

    &:disabled {
        color: ${p => p.theme.c.disabled} !important;
        opacity: 1;
    }

    &::placeholder {
        color: ${p => p.theme.c.disabled};
    }

    &:-webkit-autofill {
        border-color: ${p => p.theme.c.active};
        box-shadow: 0 0 0px 1000px ${p => p.theme.c.light} inset;
    }
`;

export const FormElement = styled.div`
    position: relative;
    margin-bottom: 16px;
`;

export const Copied = styled.div`
    position: absolute;
    top: 0;
    right: 0;
    background-color: ${p => p.theme.c.info};
    padding: 2px 4px;
    border-radius: 3px;
    color: ${p => p.theme.c.whiteOnActive};
    text-shadow: 0 0 2px ${p => p.theme.c.blackShadow3};
`;

export const ChangeButton = styled.button`
    position: absolute;
    top: 0;
    right: 0;
    background-color: transparent;
    font-weight: 300;
    font-size: 13px;
    cursor: pointer;
    border: none;
    outline: none;
`;

export const ElementLight = css`
    .ElementLight {
        background-color: ${p => p.theme.c.light};
        border-color: ${p => p.theme.c.active};
    }
`;

export const ValidationState = css`
    &.ValidationState {
        border-color: ${p => p.theme.c.wrong} !important;
    }
`;

export const FormWrapper = styled.div`
    max-width: 480px;
    margin: auto;
    padding-bottom: 24px;
`;

export const TwoInOne = styled.div`
    display: flex;

    > div {
        flex: 1;
    }

    .Gap {
        line-height: 50px;
        padding: 0 12px;
        flex: none;
    }
    .GapNormal {
        line-height: normal;
    }
`;

export const StyledButton = styled.button`
    width: 100%;

    &.button.Facebook {
        background-color: ${p => p.theme.c.facebook};

        &:hover {
            background-color: ${p => lighten(0.1, p.theme.c.facebook)};
        }
        &:focus {
            border-color: ${p => darken(0.1, p.theme.c.facebook)};
        }

        &:disabled {
            background-color: ${p => lighten(0.16, p.theme.c.facebook)};
        }
    }

    &.button.FacebookLight {
        border-color: ${p => p.theme.c.facebook};
        color: ${p => p.theme.c.facebook};

        &:hover {
            background-color: ${p => p.theme.mode === "dark" ? "transparent" : lighten(0.48, p.theme.c.facebook)};
        }
        &:focus {
            border-color: ${p => darken(0.2, p.theme.c.facebook)};
        }
        &:disabled {
            background-color: ${p => lighten(0.18, p.theme.c.disabled)};
            color: ${p => lighten(0.2, p.theme.c.facebook)};
        }
    }

    &.button.Google {
        background-color: ${p => p.theme.c.google};

        &:hover {
            background-color: ${p => lighten(0.1, p.theme.c.google)};
        }
        &:focus {
            border-color: ${p => darken(0.1, p.theme.c.google)};
        }

        &:disabled {
            background-color: ${p => lighten(0.16, p.theme.c.google)};
        }
    }

    &.button.GoogleLight {
        border-color: ${p => p.theme.c.google};
        color: ${p => p.theme.c.google};

        &:hover {
            background-color: ${p => p.theme.mode === "dark" ? "transparent" : lighten(0.42, p.theme.c.google)};
        }
        &:focus {
            border-color: ${p => darken(0.2, p.theme.c.google)};
        }
        &:disabled {
            background-color: ${p => lighten(0.18, p.theme.c.disabled)};
            color: ${p => lighten(0.2, p.theme.c.google)};
        }
    }
`;